import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsTherapistSemesterQueryKey({
  personaName,
  period,
  year
}: {
  personaName?: string
  period: number
  year: number
}) {
  return [
    'operationalCAAMetricsTherapistSemester',
    { personaName, period, year }
  ]
}

export function useOperationalCAAMetricsTherapistSemesterQuery({
  personaName,
  period,
  year,
  enabled
}: {
  personaName?: string
  period: number
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsTherapistSemesterQueryKey({
      personaName,
      period,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsTherapistSemester({
        personaName,
        period,
        year
      }),
    enabled
  })
}
